import { render, staticRenderFns } from "./TopicsSection.vue?vue&type=template&id=b16f5a2c&scoped=true&"
import script from "./TopicsSection.vue?vue&type=script&lang=js&"
export * from "./TopicsSection.vue?vue&type=script&lang=js&"
import style0 from "./TopicsSection.vue?vue&type=style&index=0&id=b16f5a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f5a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VRow,VSheet})
